module.exports = __webpack_public_path__ + "img/icon-tit_task.64d45da0.png";